module.exports = __webpack_public_path__ + "static/media/talleresdif001.8d4bbccc.jpeg";